import Root from './components/Root';
import Title from './components/Title';
import Header from './components/Header';
import HeaderLeftSide from './components/HeaderLeftSide';
import HeaderRightSide from './components/HeaderRightSide';
import Content from './components/Content';
import CloseButtonWrapper from './components/CloseButtonWrapper';
import MoreButtonWrapper from './components/MoreButtonWrapper';
import BackButtonWrapper from './components/BackButtonWrapper';
import ActionButton from './components/ActionButton';

export { OperatorPanelSettingsWrapperContext } from './hooks';

const OperatorPanelSettingsWrapper = {
  Root,
  Title,
  Header,
  HeaderLeftSide,
  HeaderRightSide,
  Content,
  CloseButton: CloseButtonWrapper,
  MoreButton: MoreButtonWrapper,
  BackButton: BackButtonWrapper,
  ActionButton,
} as const;

export default OperatorPanelSettingsWrapper;
